// Today's + tomorrow's calendar sticky notes on the Dashboard (all shifts see them).
import React, { useEffect, useState } from 'react';
import { StickyNote } from 'lucide-react';
import { apiCall } from './_shared';

const KIND = {
  info: 'bg-sky-100 text-sky-800 border-sky-200',
  vip: 'bg-amber-100 text-amber-800 border-amber-200',
  group: 'bg-violet-100 text-violet-800 border-violet-200',
  maintenance: 'bg-slate-200 text-slate-800 border-slate-300',
  warning: 'bg-red-100 text-red-800 border-red-200',
};

const iso = (d) => d.toISOString().slice(0, 10);

const DashboardNotes = ({ onOpenCalendar }) => {
  const [notes, setNotes] = useState([]);
  const today = iso(new Date());
  const tomorrow = iso(new Date(Date.now() + 86400000));

  useEffect(() => {
    const load = () => apiCall(`/api/admin/reception/calendar/notes?start=${today}&end=${iso(new Date(Date.now() + 2 * 86400000))}`)
      .then((d) => setNotes(d.notes || [])).catch(() => {});
    load();
    const id = setInterval(load, 120000);
    return () => clearInterval(id);
  }, [today]);

  if (!notes.length) return null;

  const days = [{ label: 'Today', date: today }, { label: 'Tomorrow', date: tomorrow }];
  const columns = days.map((d) => {
    const items = notes.filter((n) => n.date === d.date);
    const chips = items.map((n) => (
      <li key={n.id} className={`border rounded-lg px-2.5 py-1.5 text-sm leading-snug ${KIND[n.kind] || KIND.info}`} data-testid={`dash-note-${n.id}`}>
        <span className="text-[10px] uppercase font-bold mr-1">{n.kind}</span>{n.text}
        <span className="block text-[10px] opacity-70">{n.by}</span>
      </li>
    ));
    return (
      <div key={d.date} className="min-w-0" data-testid={`dash-notes-${d.label.toLowerCase()}`}>
        <p className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold mb-1">{d.label} · {d.date}</p>
        {items.length ? <ul className="space-y-1">{chips}</ul> : <p className="text-xs text-slate-400">No notes</p>}
      </div>
    );
  });

  return (
    <div className="bg-white rounded-xl border border-amber-200 shadow-sm p-3 sm:p-4" data-testid="dashboard-notes">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-bold text-slate-900 flex items-center gap-2 text-sm"><StickyNote className="w-4 h-4 text-amber-500" /> Calendar notes</h3>
        <button onClick={onOpenCalendar} className="text-xs text-orange-600 font-semibold hover:underline" data-testid="dashboard-notes-open-calendar">Open calendar</button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{columns}</div>
    </div>
  );
};

export default DashboardNotes;
